import { ButtonComponent } from '@/components/commons'
import { Text } from '@/components/commons/typography/Text'
import { Title } from '@/components/commons/typography/Title'
import { Modal } from '@/components/modal/Modal'
import { BrowserContext, UserContext } from 'context'
import { useContext } from 'react'
import { DealSyncSideBarModalBase } from './DealSyncSideBarModalBase'

interface DealSyncSideBarModalSyncingProps {
  isOpen: boolean
  onClose: () => void
}

export const DealSyncSideBarModalSyncing = ({
  isOpen,
  onClose,
}: DealSyncSideBarModalSyncingProps) => {
  const { isMobile } = useContext(BrowserContext)
  const { user } = useContext(UserContext)
  return (
    <Modal
      styles={{
        body: {
          padding: 0,
          background: 'transparent',
        },
        content: {
          background: 'transparent',
          overflow: 'visible',
          minWidth: !isMobile ? '500px' : undefined,
        },
      }}
      centered
      size="md"
      opened={isOpen}
      onClose={onClose}
      withCloseButton={false}
    >
      <DealSyncSideBarModalBase>
        <Title
          variation="regular"
          sizeClass="text-18"
          lineHeightClass="leading-22"
          // weightClass="font-light"
          className="text-center"
        >
          We’re still searching! No new VIP Contacts Found....Yet!
        </Title>

        <Text className="text-center mt-22">
          No contacts Found....Yet! It looks like we haven’t found any VIPs yet
          in your Gmail inbox. We’ll email you when we do, or you can check back
          later as we’re refining your results! Want more connections now?
        </Text>
        <Text className="text-center mt-22">
          Network Supercharge is an awesome way to build new relationships on
          Creatorland.
        </Text>

        <div className="flex full-w justify-center mt-22">
          <ButtonComponent
            size="regular"
            label="⚡️ JOIN NETWORK SUPERCHARGE"
            fullWidth
            onClick={onClose}
            to={`https://creatorland.typeform.com/supercharge#email=${user.email}`}
          />
        </div>
      </DealSyncSideBarModalBase>
    </Modal>
  )
}
